import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import HomeBanner3 from "../ones/HomeBanner3";
import HomeSlider from "../ones/HomeSlider";
import ServicesBanner1 from "../ones/ServicesBanner1";

export default function View(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <HomeSlider />
      <ServicesBanner1 isHome />
      <HomeBanner2 />
      <HomeBanner3 />
      <Footer />
    </>
  );
}
